export default function getPurePathName(pathname: string) {
  return pathname.startsWith("/ar") || pathname.startsWith("/en")
    ? pathname.slice(3)
    : pathname;
}
